import React, { ReactNode } from 'react';
import SectionHeader from './header';
import SectionContent from './content';
import SectionAction from './action';

type HeaderClassGroup = {
  leading?: string;
  h1?: string;
  description?: string;
};

type SectionProps = {
  id: string;
  ariaLabel?: string;
  className?: string;
  containerClassName?: string;
  wrapperClassName?: string;
  wrapperHeaderClassName?: string;
  header?: {
    classGroup?: HeaderClassGroup;
    alignment?: string;
    leading?: string;
    title?: string;
    description?: string;
    headerClassName?: string;
  };
  action?: ReactNode;
  children: ReactNode;
};

const Section = ({
  id,
  ariaLabel,
  className = '',
  containerClassName = '',
  wrapperClassName = 'flex flex-col gap-12', // Default to stacked layout
  wrapperHeaderClassName = 'flex flex-col w-full', // Default to stacked layout
  header = {},
  action,
  children
}: SectionProps) => {
  const {
    classGroup,
    alignment,
    leading,
    title,
    description,
    headerClassName = 'mb-8'
  } = header;

  return (
    <section
      id={id}
      className={className}
      aria-label={ariaLabel || (title ? String(title) : undefined)}
      aria-labelledby={title ? `${id}-heading` : undefined}
    >
      <div className={`container max-w-7xl mx-auto px-4 py-16 sm:px-6 sm:py-24 md:mt-24 ${containerClassName}`}>
        <div className={wrapperClassName}>
          <div className={wrapperHeaderClassName}>
            <SectionHeader
              classWrapper={headerClassName}
              classGroup={classGroup}
              alignment={alignment}
              leading={leading}
              title={`${title}`}
              description={description}
              headingId={`${id}-heading`}
            />
            {action && <SectionAction>{action}</SectionAction>}
          </div>

          {/* Content */}
          <div className="w-full">
            <SectionContent>{children}</SectionContent>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section;
